module.exports = __webpack_public_path__ + "img/Group 525.5884ee4a.svg";